import React, { Component } from 'react'
import { Button, Card, Divider, Header, Icon } from 'semantic-ui-react'
import _ from 'lodash'
import firebase from 'firebase/app'

import Placeholder from './storePlaceholder'

import CrossSellItemCard from './CrossSellItemCard'
import CrossSellItemForm from '../forms/crossSellItemForm'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  headerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'space-between',
    padding: '0px 14px',
  },
  addIconWrapper: {
    display: 'flex',
  },
  optionsWrapper: {
    overflow: 'auto',
  },
  optionNameWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}

class CrossSellItemsList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      action: '',
      formVisible: false,
      crossSellBranch: [],
      crossSellItems: props.crossSellItems,
    }
  }

  componentDidUpdate(prevProps) {
    const { crossSellItems } = this.props

    if (prevProps.crossSellItems !== crossSellItems) {
      this.setState({ crossSellItems })
    }
  }

  onEditClick = data => {
    this.setState({ crossSellBranch: data, action: 'edit', formVisible: true })
  }

  onDeleteClick = async docId => {
    const { crossSellItems } = this.state
    const { setCrossSellItems } = this.props

    const confirm = window.confirm(`Are you sure to delete this cross-sell items?`)

    try {
      if (!docId) throw new Error('Failed to delete cross-sell items, ref not found')

      if (confirm) {
        const crossSellRef = firebase.firestore().collection('cross_sell_items').doc(docId)
        const remainingBranch = crossSellItems.filter(item => item.doc_id !== docId )

        await crossSellRef.delete()

        setCrossSellItems(remainingBranch)
      }
    } catch (error) {
      alert(error || error.message)
    }
  }

  renderCrossSellItems = () => {
    const { crossSellItems } = this.state
    const { items, branches } = this.props

    if (_.size(crossSellItems) === 0) {
      return <Header textAlign='center' size="small" style={{ padding: 16 }}>No data available</Header>
    }

    return (
      <div style={styles.optionsWrapper} className="branches-summary">
        <Card.Group style={{ margin: 0 }} itemsPerRow={3}>
          {crossSellItems.map(crossSellBranch => {
            const { doc_id: docId, branch_id: branchId } = crossSellBranch
            const branch = branches.find(bran => bran.id === branchId) || []
            const branchName = _.get(branch, 'name', 'N/A')

            return (
              <CrossSellItemCard
                key={branchId}
                data={crossSellBranch}
                items={items}
                branchName={branchName}
                onEdit={() => this.onEditClick(crossSellBranch)}
                onDelete={() => this.onDeleteClick(docId)}
              />
            )
          })}
        </Card.Group>
      </div>
    )
  }

  renderLoading = () => <Placeholder />

  renderContent = () => {
    const { formVisible, action, crossSellBranch, crossSellItems } = this.state
    const { branches, items, merchantId, getCrossSellItems } = this.props

    const crossSellItemBranchIds = crossSellItems.map(data => data.branch_id)

    const branchOptions = action === 'edit'
      ? [branches.find(branch => branch.id === crossSellBranch.branch_id)]
      : branches.filter(branch => !crossSellItemBranchIds.includes(branch.id))

    return (
      <React.Fragment>
        <div style={styles.container}>
          <div style={styles.headerWrapper}>
            <Header style={{ margin: 0 }}>Cross-sell Items</Header>
            <Button
              icon
              color="black"
              onClick={() => this.setState({ formVisible: true, action: 'create' })}
            >
              <Icon name="add" /> Add New
            </Button>
          </div>

          <Divider style={{ margin: 14 }} />
          {this.renderCrossSellItems()}
        </div>ł

        {formVisible ? (
          <CrossSellItemForm
            action={action}
            visible={formVisible}
            merchantId={merchantId}
            items={items}
            branches={branchOptions}
            crossSellBranch={crossSellBranch}
            onClose={() => this.setState({ formVisible: false })}
            getCrossSellItems={getCrossSellItems}
          />
        ) : null}
      </React.Fragment>
    )
  }

  render() {
    const { loading } = this.props

    if (loading) return this.renderLoading()

    return this.renderContent()
  }
}

export default CrossSellItemsList


// WEBPACK FOOTER //
// ./src/components/restaurants/views/CrossSellItemsList.js